<template>
  <span :class="['watch', verification === '' && 'watch--simple']">
    {{ verification }}
    <span class="watch__hours" v-bind:style="hourRotation"></span>
    <span class="watch__minutes" v-bind:style="minuteRotation"></span>
    <span class="watch__dot"></span>
  </span>
</template>

<script>

export default {
  name: 'Watch',
  props: [
    'verification'
  ],
  methods: {

  },
  computed: {
    hourRotation () {
      let hour = this.$store.state.selectedTime.slice(0, 2);
      let minutes = this.$store.state.selectedTime.slice(3);

      //transform into 12 hour clock for easier handling
      hour = hour % 12;
      hour = hour ? hour : 12;
      let degrees = -90 + (hour * 30);
      if (minutes === '30') {
        degrees = degrees + 10;
      }
      return {
        transform: `rotate(${degrees}deg)`,
      }
    },
    minuteRotation () {
      let minutes = this.$store.state.selectedTime.slice(3);
      let degrees;
      if (minutes === '30') {
        degrees = '90'
      } else {
        degrees = '-90';
      }
      return {
        transform: `rotate(${degrees}deg)`,
      }
    }
  }
}
</script>

<style scoped>
.watch {
  background-color: var(--green--dark);
  border-radius: 50%;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.36);
  display: inline-block;
  height: 83px;
  min-width: 83px;
  position: relative;
  width: 83px;
}

.watch.watch--simple {
  background-color: var(--green--light);
  position: absolute;
  left: -75px;
  height: 46px;
  min-width: 46px;
  width: 46px;
}

.watch--simple .watch__hours {
  background-color: var(--green--dark);
  width: 15px;
}
.watch--simple .watch__minutes {
  background-color: var(--green--dark);
  width: 20px;
}
.watch--simple .watch__dot {
  background-color: var(--green--dark);
}

@media only screen and (max-width: 900px) {
  .watch.watch--simple {
    margin-bottom: 15px;
    position: relative;
    left: 0;
  }
}

.watch__hours {
  background-color: white;
  border-top-left-radius: 4px;
  border-bottom-right-radius: 4px;
  height: 2px;
  position: absolute;
  top: calc(50% - 1px);
  left: 50%;
  width: 25px;
  transform-origin: left center;
}

.watch__minutes {
  background-color: white;
  border-top-left-radius: 4px;
  border-bottom-right-radius: 4px;
  height: 2px;
  position: absolute;
  top: calc(50% - 1px);
  left: 50%;
  width: 35px;
  transform-origin: left center;
}

.watch__dot {
  background-color: var(--green);
  border-radius: 50%;
  height: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 5px;
}

@media only screen and (max-width: 500px) {
  .time__watch {
    margin: 0 auto 20px;
  }
}
</style>
